'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Otoire = void 0;
var $ = require("jquery");
var howler_1 = require("howler");
var Otoire = /** @class */ (function () {
    function Otoire() {
        var _this = this;
        this.sound = new howler_1.Howl({
            src: '/dest/sounds/otoire/sound01.mp3',
            loop: true
        });
        this.volumeParam = 1;
        this.setFadeOutTime = 2000;
        this.nowStopping = false;
        $('.trigOtoireButton').on('click', function (e) {
            var isPlay = $(e.currentTarget).attr('data-is-play');
            if (isPlay === 'false') {
                _this.nowStopping = false;
                _this.changeNoSelect();
                _this.sound.stop();
                _this.setSound();
                _this.setVolume();
                _this.sound.volume(_this.volumeParam);
                _this.sound.play();
                $('.bulletOtoireSwitch').attr('data-is-play', 'true');
                $('.bulletOtoireImage').attr('data-is-play', 'true');
            }
            else {
                _this.nowStopping = true;
                _this.changeAllSelect();
                _this.sound.fade(_this.volumeParam, 0, _this.setFadeOutTime);
                $('.bulletOtoireSwitch').attr('data-is-play', 'false');
                $('.bulletOtoireImage').attr('data-is-play', 'false');
            }
        });
        $('#paramVolume').on('change', function () {
            if (!_this.nowStopping) {
                _this.setVolume();
                _this.sound.volume(_this.volumeParam);
            }
        });
    }
    Otoire.prototype.setSound = function () {
        var select = $('.paramOtoireSelect:checked').val();
        var dir = '/dest/sounds/otoire/';
        var file = 'sound01.mp3';
        switch (select) {
            case ("1"):
                file = 'sound01.mp3';
                break;
            case ('2'):
                file = 'sound02.mp3';
                break;
            case ('3'):
                file = 'sound03.mp3';
                break;
            case ('4'):
                file = 'sound04.mp3';
                break;
        }
        this.sound = new howler_1.Howl({
            src: "" + (dir + file),
            loop: true
        });
    };
    Otoire.prototype.setVolume = function () {
        var volume = $('#paramVolume').val() * 0.1;
        this.volumeParam = volume;
    };
    Otoire.prototype.changeNoSelect = function () {
        $('.paramOtoireSelect').prop('disabled', true);
    };
    Otoire.prototype.changeAllSelect = function () {
        $('.paramOtoireSelect').prop('disabled', false);
    };
    return Otoire;
}());
exports.Otoire = Otoire;
exports.default = Otoire;
